import { useState } from 'react';

// Bộ màu nhấn nhân viên tự chọn (7 màu như thiết kế mới). "emerald" (tên khoá cũ, giữ để
// không vỡ lựa chọn đã lưu) = mặc định Indigo (xóa data-accent). Thứ tự khớp giao diện mới.
const ACCENTS = [
  { key: 'emerald', label: 'Indigo', color: '#4b47e6' },
  { key: 'ocean', label: 'Blue', color: '#2563eb' },
  { key: 'teal', label: 'Teal', color: '#0d9488' },
  { key: 'green', label: 'Green', color: '#16a34a' },
  { key: 'violet', label: 'Violet', color: '#7c3aed' },
  { key: 'coral', label: 'Rose', color: '#e11d48' },
  { key: 'amber', label: 'Orange', color: '#d97706' },
];
const VALID = ACCENTS.map((a) => a.key).filter((k) => k !== 'emerald');

function currentAccent() {
  const a = localStorage.getItem('ft-accent');
  return VALID.includes(a) ? a : 'emerald';
}

export default function AccentPicker() {
  const [accent, setAccent] = useState(currentAccent);

  function pick(key) {
    setAccent(key);
    if (key === 'emerald') {
      document.documentElement.removeAttribute('data-accent');
      localStorage.removeItem('ft-accent');
    } else {
      document.documentElement.setAttribute('data-accent', key);
      localStorage.setItem('ft-accent', key);
    }
  }

  return (
    <div style={{ marginTop: 12 }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'var(--sb-label, rgba(255,255,255,0.42))',
          marginBottom: 9,
          paddingLeft: 2,
        }}
      >
        Màu nhấn
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', paddingLeft: 2 }}>
        {ACCENTS.map((a) => (
          <button
            key={a.key}
            onClick={() => pick(a.key)}
            title={`Màu ${a.label}`}
            aria-label={`Màu ${a.label}`}
            style={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              background: a.color,
              cursor: 'pointer',
              padding: 0,
              // Luôn nằm trên nền sidebar tối cố định -> dùng màu sáng cứng thay vì var(--text)/var(--border).
              border: accent === a.key ? '2px solid var(--sb-ring, #ffffff)' : '2px solid transparent',
              boxShadow: accent === a.key ? '0 0 0 1px var(--sb-ring-soft, rgba(255,255,255,0.55))' : '0 0 0 1px var(--sb-ring-soft, rgba(255,255,255,0.2))',
            }}
          />
        ))}
      </div>
    </div>
  );
}
